import React from "react";
import Layout from "../components/productsPage/Layout";
import Footer from "../components/shared/footer/Footer";
import Header from "../components/shared/header/Header";

const Products = () => {
  return (
    <div>
      <Header />
      <Layout />
      <Footer />
    </div>
  );
};

export default Products;
